import {gql} from '@apollo/client';

import {Maybe} from '#apollo/schema';

export const ActionPlanAdjustmentListFragment = gql`
  fragment ActionPlanAdjustmentListFragment on HealthFactorAdjustment {
    id
    selected
    healthFactorAssessment {
      healthFactor {
        id
        recommendedResponse
        title
      }
      id
    }
    recommendedResponse
  }
`;

export interface ActionPlanAdjustment {
  id: string;
  selected: boolean;
  healthFactorAssessment?: Maybe<{
    healthFactor?: Maybe<{
      id: string;
      recommendedResponse?: Maybe<string>;
      title?: Maybe<string>;
    }>;
    id: string;
  }>;
  recommendedResponse?: Maybe<string>;
}

export interface ActionPlanAdjustmentListProps extends React.ComponentPropsWithoutRef<'ul'> {
  adjustments?: ActionPlanAdjustment[];
  /**
   * Determines the rendered UI variant for the ActionPlanAdjustmentList
   */
  variant?: 'primary' | 'inline';
}
